import { useState } from 'react';
import type { Ventilation } from './types';

interface VentilationModalProps {
  totalHours: number;
  onSave: (v: Ventilation) => void;
  onCancel: () => void;
  existing?: Ventilation;
}

export function VentilationModal({ totalHours, onSave, onCancel, existing }: VentilationModalProps) {
  const [vals, setVals] = useState<Ventilation>(existing || { etude: 0, suivi: 0, mise_en_service: 0, chantier: 0 });
  const currentTotal = vals.etude + vals.suivi + vals.mise_en_service + vals.chantier;
  const diff = totalHours - currentTotal;
  const isValid = Math.abs(diff) < 0.01;

  const update = (field: keyof Ventilation, val: string) => {
    const num = parseFloat(val) || 0;
    setVals({ ...vals, [field]: num });
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter:'blur(4px)', zIndex: 1100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ background: 'white', padding: '32px', borderRadius: '24px', width: '90%', maxWidth: '450px', boxShadow:'0 25px 50px -12px rgba(0, 0, 0, 0.2)' }}>
        <h3 style={{ marginTop: 0, color:'#1e293b', fontSize:'1.3rem' }}>Ventilation Analytique</h3>
        <p style={{ color: '#64748b', marginBottom: '24px', fontSize:'1rem' }}>
          Répartition des <strong>{totalHours}h</strong> saisies.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <label style={{fontSize:'0.95rem', fontWeight:'600', color:'#475569'}}>Bureau d'Étude / Conception
            <input type="number" step="0.01" value={vals.etude || ''} onChange={e => update('etude', e.target.value)} style={{ width: '100%', padding: '12px', marginTop: '6px', borderRadius:'10px', border:'1px solid #cbd5e1', fontSize:'1.1rem' }} />
          </label>
          <label style={{fontSize:'0.95rem', fontWeight:'600', color:'#475569'}}>Suivi de Chantier
            <input type="number" step="0.01" value={vals.suivi || ''} onChange={e => update('suivi', e.target.value)} style={{ width: '100%', padding: '12px', marginTop: '6px', borderRadius:'10px', border:'1px solid #cbd5e1', fontSize:'1.1rem' }} />
          </label>
          <label style={{fontSize:'0.95rem', fontWeight:'600', color:'#475569'}}>Mise en Service
            <input type="number" step="0.01" value={vals.mise_en_service || ''} onChange={e => update('mise_en_service', e.target.value)} style={{ width: '100%', padding: '12px', marginTop: '6px', borderRadius:'10px', border:'1px solid #cbd5e1', fontSize:'1.1rem' }} />
          </label>
          <label style={{fontSize:'0.95rem', fontWeight:'600', color:'#475569'}}>Chantier (Câblage)
            <input type="number" step="0.01" value={vals.chantier || ''} onChange={e => update('chantier', e.target.value)} style={{ width: '100%', padding: '12px', marginTop: '6px', borderRadius:'10px', border:'1px solid #cbd5e1', fontSize:'1.1rem' }} />
          </label>
        </div>

        <div style={{ marginTop: '24px', padding: '16px', background: isValid ? '#dcfce7' : '#fee2e2', color: isValid ? '#166534' : '#991b1b', borderRadius: '12px', textAlign: 'center', fontWeight: 'bold', fontSize:'1rem' }}>
          Reste à ventiler : {diff.toFixed(2)} h
        </div>

        <div style={{ display: 'flex', gap: '16px', marginTop: '24px' }}>
          <button onClick={onCancel} style={{ flex: 1, padding: '14px', background:'white', border:'1px solid #cbd5e1', borderRadius:'12px', cursor:'pointer', fontSize:'1.1rem', color:'#64748b', fontWeight:'600' }}>Annuler</button>
          <button onClick={() => onSave(vals)} disabled={!isValid} style={{ flex: 1, padding: '14px', background: isValid ? '#10b981' : '#e2e8f0', color: isValid?'white':'#94a3b8', fontWeight: 'bold', border: 'none', borderRadius: '12px', cursor: isValid?'pointer':'not-allowed', fontSize:'1.1rem' }}>OK</button>
        </div>
      </div>
    </div>
  );
}
